export const getTranslateX = (value: number | string = 0) =>
  `translateX(${typeof value === 'number' ? `${value}px` : value})`;

export const createBorderRadius = (left: number, right: number) =>
  `${left}px ${right}px ${right}px ${left}px`;
